module.exports = "<div>\n    <mat-icon (click)=\"close()\">close</mat-icon>\n</div>\n<p [innerHtml]=\"value\"></p>\n\n<!-- <img [src]=\"value\"> -->"